import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, impressaoLicenciamentoVeiculos } from './types';

export const INITIAL_STATE: impressaoLicenciamentoVeiculos = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): impressaoLicenciamentoVeiculos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRESSAO_LICENCIAMENTO_VEICULOS_REQUEST: {
				break;
			}

			case Types.IMPRESSAO_LICENCIAMENTO_VEICULOS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_LICENCIAMENTO_VEICULOS_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.IMPRESSAO_LICENCIAMENTO_VEICULOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
